import { render, staticRenderFns } from "./contact-candidate.vue?vue&type=template&id=6c28e88a&"
import script from "./contact-candidate.vue?vue&type=script&lang=js&"
export * from "./contact-candidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports